module.exports = __webpack_public_path__ + "img/4bac313.webp";